import {useState} from 'react'

import Button from '@mui/material/Button'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import Checkbox from '@mui/material/Checkbox'
import DownloadIcon from '@mui/icons-material/Download'
import FormControlLabel from '@mui/material/FormControlLabel'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import PrintIcon from '@mui/icons-material/Print'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import {styled} from '@mui/material/styles'

import './backupCodes.scss'

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: (theme.vars ?? theme).palette.text.primary,
}))

const BackupCodes = props => {
  const [copied, setCopied] = useState(false)
  const [saved, setSaved] = useState(false)

  const codesText = props.backupCodes.map(backupCode => backupCode.code).join('\n')

  const handleCopy = () => {
    navigator.clipboard.writeText(codesText)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  const handlePrint = () => {
    const printWindow = window.open('', '_blank')
    printWindow.document.write(`<pre>${codesText}</pre>`)
    printWindow.document.close()
    printWindow.print()
  }

  const handleDownload = () => {
    const blob = new Blob([codesText], {type: 'text/plain'})
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = 'accounts-backup-codes.txt'
    link.click()
    URL.revokeObjectURL(url)
  }

  return (
    <Paper elevation={3} component='div' className='backup-codes'>
      <Stack spacing={2} component='div' sx={{marginBottom: '25px'}}>
        <Typography variant='h4' gutterBottom>Backup Codes</Typography>
        <Typography variant='body1' gutterBottom>
          Please copy the backup codes below and keep them in a safe place. You can use these codes to access your account if you lose access to your primary MFA method.
        </Typography>
      </Stack>
      <Grid container spacing={2} sx={{marginBottom: '25px'}}>
        {
          props.backupCodes.map(backupCode => (
            <Grid key={backupCode.id} size={{xs: 6, sm: 4}}>
              <Item className='code'>
                {backupCode.code}
              </Item>
            </Grid>
          ))
        }
      </Grid>
      <Stack direction={{xs: 'column', sm: 'row'}} spacing={1} justifyContent='space-evenly' className='actions'>
        <Button variant='outlined' startIcon={<ContentCopyIcon />} onClick={handleCopy}>
          {copied ? 'Copied' : 'Copy'}
        </Button>
        <Button variant='outlined' startIcon={<PrintIcon />} onClick={handlePrint}>
          Print
        </Button>
        <Button variant='outlined' startIcon={<DownloadIcon />} onClick={handleDownload}>
          Download
        </Button>
      </Stack>
      <Stack spacing={2} component='div'>
        <FormControlLabel
          control={<Checkbox checked={saved} onChange={() => setSaved(!saved)} sx={{color: '#4E9E9A'}} />}
          label='I have saved my backup codes'
        />
        <Button
          disabled={props.loading || !saved}
          className='action'
          color='primary'
          onClick={props.enableTfa}
          variant='contained'>
          Done
        </Button>
      </Stack>
    </Paper>
  )
}

export default BackupCodes
